// extracted by mini-css-extract-plugin
export default {"authorSocials":"authorSocials_rSDt","authorSocialLink":"authorSocialLink_owbf","authorSocialIcon":"authorSocialIcon_XYv3"};